import BotifyAPI from 'dashboard/api/BotifyAPI';

class Botify extends BotifyAPI {
  constructor() {
    super('botify', { accountScoped: true });
  }
}

export default new Botify();
